import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { useRequestIntervention } from 'app/interventions/composables/use-request-intervention';
import { useResendLinkRequest } from 'app/link-requests/composables/use-resend-link-request';
import { AnalyticsService } from 'app/shared/services/analytics.service';

import { useMarkNotificationAsRead } from '../composables/use-mark-notification-as-read';
import { NotificationTab, NotificationView } from '../models/notification-view';

@Injectable({ providedIn: 'root' })
export class NotificationActionService {
    private readonly router = inject(Router);
    private readonly analytics = inject(AnalyticsService);
    private readonly markNotificationAsRead = useMarkNotificationAsRead();
    private readonly resendLinkRequest = useResendLinkRequest();
    private readonly requestIntervention = useRequestIntervention({ analyticsSource: 'Notification' });

    handle(notification: NotificationView, tab: NotificationTab): void {
        this.markNotificationAsRead.markAsRead(notification.id);
        switch (notification.type) {
            case 'linkRequestReminder':
                if (notification.linkRequestOID) {
                    this.analytics.resendLinkRequestFromNotification();
                    this.resendLinkRequest.resend(notification.linkRequestOID);
                }
                return;
            case 'interventionExpired':
                if (notification.siteOID) {
                    this.analytics.resendRemoteServiceRequestFromNotification();
                    this.requestIntervention.requestIntervention(notification.siteOID);
                }
                return;
            case 'admin':
                this.analytics.viewMessageDetailFromNotification();
                this.router.navigate(['/notifications', 'view', notification.id], { queryParams: { from: tab } });
                break;
            case 'linkRequest':
                this.router.navigate(
                    notification.gatewayId ? ['/gateway', notification.gatewayId] : ['/link-requests'],
                );
                break;
            case 'alertReminder':
                this.analytics.accessAlertsListFromNotification();
                this.router.navigate(['/alerts']);
                break;
        }
    }
}
